import { translate } from "../../localization";

export const formatShowFilterTitle = (title: string) => {
  const filterTitle = title.replace(/veure/gi, "")?.trim();
  return filterTitle.charAt(0).toUpperCase() + filterTitle.slice(1);
};

export const normalizeDeletedFilterBooleanValue = (value) => (value === true ? translate("filters.deleted") : value);

export const normalizeEmptyFilterValue = (value, filterTitle) => (value === "" ? formatEmptyFilterValue(filterTitle) : value);

const formatEmptyFilterValue = (filterTitle) => {
  const chipLabel = `${translate("chipHeader.without")} ${filterTitle.toLowerCase()}`;
  return chipLabel;
};
